@if (htmlPath && htmlFile && routerPath) {
  <div>
    <ch-manual
      [assetsPath]="htmlPath"
      [page]="htmlFile"
      [showControls]="false"
      [addContainer]="true"
      [routerPath]="routerPath"
      [manualStyles]="false"></ch-manual>
  </div>
}
